import { endOfMonth, format, startOfMonth, startOfYear, subMonths } from "date-fns";

const iso = (d) => format(d, "yyyy-MM-dd");

const DEFS = [
  ["this_month", "This month", (t) => [startOfMonth(t), t]],
  ["last_month", "Last month", (t) => [startOfMonth(subMonths(t, 1)), endOfMonth(subMonths(t, 1))]],
  ["last_3_months", "Last 3 months", (t) => [startOfMonth(subMonths(t, 2)), t]],
  ["last_12_months", "Last 12 months", (t) => [startOfMonth(subMonths(t, 11)), t]],
  ["ytd", "Year to date", (t) => [startOfYear(t), t]],
];

export const QUICK_RANGES = DEFS.map(([key, label, get]) => ({ key, label, range: () => get(new Date()).map(iso) }));

export function rangeError(from, to, view) {
  if (!from || !to) return "Select both From and To dates";
  if (from > to) return "From date must be before To date";
  if (view === "daily" && (Date.parse(to) - Date.parse(from)) / 86400000 + 1 > 366) return "Daily view supports up to 366 days";
  return "";
}

export const pctText = (v) => (v == null ? "—" : `${v.toFixed(1)}%`);
